/**
 * 模块: SVG定义（渐变和滤镜）
 * 职责: 创建SVG渐变、阴影等视觉效果
 * 限制: 文件<280行
 */

import * as d3 from 'd3';

/**
 * 添加SVG定义（渐变和滤镜）
 */
export function addSVGDefs(svg: d3.Selection<SVGSVGElement, unknown, null, undefined>) {
  const defs = svg.append('defs');
  
  // 自有品牌渐变（蓝色）
  const ownBrandGradient = defs.append('radialGradient')
    .attr('id', 'own-brand-gradient');
  ownBrandGradient.append('stop')
    .attr('offset', '0%')
    .attr('stop-color', '#40a9ff');
  ownBrandGradient.append('stop')
    .attr('offset', '100%')
    .attr('stop-color', '#1890ff');
  
  // 竞争品牌渐变（橙色）
  const competitorGradient = defs.append('radialGradient')
    .attr('id', 'competitor-gradient');
  competitorGradient.append('stop')
    .attr('offset', '0%')
    .attr('stop-color', '#ffc53d');
  competitorGradient.append('stop')
    .attr('offset', '100%')
    .attr('stop-color', '#faad14');
  
  // 节点阴影
  const filter = defs.append('filter')
    .attr('id', 'node-shadow')
    .attr('height', '200%');
  
  filter.append('feGaussianBlur')
    .attr('in', 'SourceAlpha')
    .attr('stdDeviation', 3);
  
  filter.append('feOffset')
    .attr('dx', 2)
    .attr('dy', 2)
    .attr('result', 'offsetblur');
  
  const feMerge = filter.append('feMerge');
  feMerge.append('feMergeNode');
  feMerge.append('feMergeNode')
    .attr('in', 'SourceGraphic');
}

